export default __webpack_public_path__ + "static/media/notsubset~kzeVqEop.8ef38fbe.svg";